import { useEffect, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { Input, Textarea } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

type SaveModalProps = {
  open: boolean
  onClose: () => void
  onClickSave: (res: { name: string; description: string; saveAsNew: boolean }) => Promise<void>
  showSaveAsNewReport?: boolean
  name?: string
  description?: string
}

export const SaveModal = ({
  open,
  onClose,
  onClickSave,
  showSaveAsNewReport,
  name,
  description,
}: SaveModalProps) => {
  const handleClose = () => {
    onClose()
  }
  const handleClickSave = async (saveAsNew = false) => {
    await onClickSave({ name: reportName, description: reportDescription, saveAsNew })
    handleClose()
  }
  const [reportName, setReportName] = useState(name || '')
  const [reportDescription, setReportDescription] = useState(description || '')

  useEffect(() => {
    setReportName(name || '')
  }, [name])

  useEffect(() => {
    setReportDescription(description || '')
  }, [description])

  return (
    <F0Dialog
      isOpen={open}
      onClose={handleClose}
      title={i18n.t('ai_reports.save_modal.title')}
      primaryAction={{
        label: i18n.t('ai_reports.save_modal.save'),
        onClick: () => handleClickSave(),
        disabled: !reportName,
      }}
      secondaryAction={
        showSaveAsNewReport
          ? {
              label: i18n.t('ai_reports.save_modal.save_as_new_report'),
              onClick: () => handleClickSave(true),
            }
          : undefined
      }
    >
      <Box flexDirection="column" gap="s16">
        <Input
          label={i18n.t('ai_reports.save_modal.report_name')}
          placeholder={i18n.t('ai_reports.save_modal.report_name_placeholder')}
          value={reportName}
          onChange={(value) => setReportName(value)}
          maxLength={100}
          required
        />
        <Textarea
          label={i18n.t('ai_reports.save_modal.report_description')}
          placeholder={i18n.t('ai_reports.save_modal.report_description_placeholder')}
          value={reportDescription}
          maxLength={100}
          onChange={(value) => setReportDescription(value)}
        />
      </Box>
    </F0Dialog>
  )
}
